import { PatientEntityType } from "@/lib/supabase/supabaseTypes";
import { Merge } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { PinPatient } from "@/dentlab/src/pages/patient-page/pin-patient.component";
import { SheetHeaderProps } from "../../sheet-provider/sheetRegistry";

export const PatientSheetActions: React.FC<{ patient: PatientEntityType } & SheetHeaderProps> = ({ patient }) => {
  const navigate = useNavigate();
  
  const handleMergePatient = () => {
    if (patient?.id) {
      navigate(`/patienten-zusammenlegen/${patient.id}`);
    }
  };

  return patient && (
    <div className="flex items-center gap-2">
      <PinPatient patient={patient} />
      <button
        onClick={handleMergePatient}
        className="p-1 rounded hover:bg-gray-100 transition-colors"
        title="Patient zusammenlegen"
      >
        <Merge className="w-4 h-4 text-gray-600" />
      </button>
    </div>
  );
};
